import { Injectable, OnChanges } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Login, Session} from './user.types';
import {environment} from '../../environments/environment';
import * as md5 from 'md5';
import {Subject} from 'rxjs/Subject';
import {Headers, Http} from '@angular/http';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import 'rxjs/add/operator/do';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
// import 'rxjs/add/observable/do';

@Injectable()
export class AuthService implements OnChanges {

    private session$: ReplaySubject<Session>;
    headers;

    constructor(private http: Http) {
        this.session$ = new ReplaySubject(1);

        this.session$.subscribe((session) => localStorage.setItem('sessionId', session.sessionId));

        Observable.timer(0, 5 * 60 * 1000)
            .subscribe(() => this.refresh());
        // Observable.timer(0, 1000)
        //     .subscribe(() => this.refresh());
    }

    ngOnChanges() {
      this.session$.subscribe(session =>
        Observable.timer(0, 1000)
        .subscribe(() => this.refresh())
      )
    }

    setSession(session) {
      this.session$.next(session)
    }

    getSession(): Observable<Session> {
        return this.session$;
    }

    /**
     * @description retuns Obersable of boolean indicating if the user has an authenticated session
     * @returns {Observable<boolean>}
     */
    isLoggedIn(): Observable<boolean> {
        return this.session$
            .map(session => {
                if (!session) {
                  localStorage.removeItem('loggedIn')
                    return false;
                }

                return session.isLoggedIn;
            });
    }

    /**
     * @description Send login request and return Observable which resolves to success status.
     * @param {Login} login
     * @returns {Observable<boolean>}
     */
    login(login: Login): Observable<boolean> {
        const loginClone = Object.assign({}, login);
        loginClone.password = md5(login.password);
        const loginResult$: Subject<boolean> = new Subject();
        this.http.post(environment.apiBaseUrl + 'user/login', loginClone)
            .map((response) =>  this.testFunction(response))
            .subscribe(session => {
              console.log(session.headers)
              this.refresh();
              loginResult$.next(session.isLoggedIn === true);
            }, (error) => {
                loginResult$.error(error);
            });

        return loginResult$;
    }

    testFunction(response) {
      this.headers = response.headers;
      this.session$.next(response._body);

      localStorage.setItem('sessionId', this.headers.get('bonanza-session-id'))

      return response.json()
    }

    refresh(): Observable<Session> {
        const headers = new Headers();
        const sIdSession = localStorage.getItem('sessionId');
        if (sIdSession) {
            headers.append('Bonanza-Session-Id', sIdSession);
            headers.append('Accept', 'application/json');
            // headers.delete("Content-Type");
        }

        this.http.get(environment.apiBaseUrl + 'user/sessionData', {headers: headers})
            .map(response => response.json())
            .subscribe(session => {
                if (!session.sessionId) {
                    session.sessionId = headers.get('Bonanza-Session-Id');
                }
                localStorage.setItem('sessionData', JSON.stringify(session))
                this.session$.next(session);
            });

        return this.session$;
    }

    logout(): Observable<any> {
        const headers = new Headers();
        headers.append('Bonanza-Session-Id', localStorage.getItem('sessionId'));

        localStorage.removeItem('sessionId');

        return this.http.get(environment.apiBaseUrl + 'user/logout', {headers: headers})
            .map(response => response.json())
            .do(session => this.session$.next(session));
    }
}



// WEBPACK FOOTER //
// ./src/app/users/auth.service.ts